<script setup lang="ts">
defineProps<{ titleId?: string }>()
</script>

<template>
  <div
    class="flex flex-col justify-start gap-2 self-stretch"
    :class="$slots.body ? 'p-2' : 'px-2 py-1.5'"
  >
    <div class="flex flex-col gap-0.5">
      <div
        v-if="$slots.title"
        :id="titleId"
        class="text-sm-12px-default font-medium text-text-inverted-irreversible select-none"
      >
        <slot name="title" />
      </div>
      <div
        v-if="$slots.body"
        class="text-sm-12px-light text-text-inverted-subtle-irreversible select-none"
      >
        <slot name="body" />
      </div>
    </div>
    <slot name="button" />
  </div>
</template>
